import styled from 'styled-components';

import Text from 'components/core/typography/Text';
import { DialogBodyCSS } from 'components/ui/layouts/DialogLayout';

import { SPACE_200, SPACE_600 } from 'styles/tokens';

export const OptionsContainer = styled.div`
  ${DialogBodyCSS}

  > ${Text} {
    justify-content: center;
    padding: ${SPACE_200} ${SPACE_200} ${SPACE_600} ${SPACE_200};
    text-align: center;
    width: 100%;

    &:last-child {
      padding-bottom: 0;
    }
  }

  > div {
    align-self: normal;
    display: flex;
    flex-direction: row;
    gap: ${SPACE_200};
    width: 100%;

    > button {
      margin-bottom: 0;
    }
  }
`;
